import {
  BillingPaymentResponseDto,
  BillingPlansResponseDto,
  PlanDebtDataDto,
} from '@tiendanube/common';
import { cirrusApi } from 'App/rtk';
import getUrlWithParams from 'commons/utils/getUrlWithParams';
import { checkoutTags } from 'domains/Billing/Checkout/CheckoutApi/config';
import {
  billingPlansEndpoints,
  billingPlansTags,
  BASE_BILLING_PLANS_URL,
  UPDATE_PLAN_URL,
  CREATE_PAYMENT_TO_UPDATE_PLAN_URL,
  GET_PLAN_DEBT_DATA,
} from './config';

export const billingPlansApi = cirrusApi
  .enhanceEndpoints({
    addTagTypes: [
      ...Object.values(billingPlansTags),
      checkoutTags.subscriptions,
      checkoutTags.scheduledPlanDowngrade,
      checkoutTags.recurrentPaymentChargesData,
    ],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      [billingPlansEndpoints.getPlans]: builder.query<
        BillingPlansResponseDto,
        void
      >({
        query: () => ({
          method: 'GET',
          url: BASE_BILLING_PLANS_URL,
        }),
        providesTags: [billingPlansTags.billingPlansList],
      }),
      [billingPlansEndpoints.updatePlan]: builder.mutation<
        BillingPaymentResponseDto,
        number
      >({
        query: (id) => ({
          method: 'POST',
          url: getUrlWithParams(UPDATE_PLAN_URL, { id }),
        }),
        invalidatesTags: [
          checkoutTags.scheduledPlanDowngrade,
          checkoutTags.subscriptions,
          checkoutTags.recurrentPaymentChargesData,
          billingPlansTags.billingPlansList,
        ],
        onQueryStarted(id, { dispatch, queryFulfilled }) {
          queryFulfilled.then(({ data: { needRedirect } }) => {
            if (needRedirect) return;
            dispatch(
              cirrusApi.util.updateQueryData(
                billingPlansEndpoints.getPlans as never,
                undefined as never,
                (billing: BillingPlansResponseDto) => {
                  const updatedPlan = billing.plansList.find(
                    (plan) => plan.id === id,
                  );
                  if (updatedPlan) billing.currentPlan = updatedPlan;
                },
              ),
            );
          });
        },
      }),
      [billingPlansEndpoints.getPlanDebtData]: builder.query<
        PlanDebtDataDto,
        void
      >({
        providesTags: () => [billingPlansTags.planDebtData],
        query: () => ({
          method: 'GET',
          url: GET_PLAN_DEBT_DATA,
        }),
      }),
      [billingPlansEndpoints.createPaymentToUpdatePlan]: builder.mutation<
        BillingPaymentResponseDto,
        string
      >({
        query: (id) => ({
          method: 'POST',
          url: getUrlWithParams(CREATE_PAYMENT_TO_UPDATE_PLAN_URL, { id }),
        }),
        invalidatesTags: (_, error) =>
          error ? [] : [billingPlansTags.billingPlansList],
      }),
    }),
  });

export const {
  useGetPlansQuery,
  useGetPlanDebtDataQuery,
  useUpdatePlanMutation,
  useCreatePaymentToUpdatePlanMutation,
} = billingPlansApi;
